import { parseToCues } from "subtitletools";
import type { EditorSubtitleLoadResult } from "./adapters";

export interface SubtitleFileLoaderMessages {
  readError: string;
  emptyError: string;
}

const DEFAULT_MESSAGES: SubtitleFileLoaderMessages = {
  readError: "Could not read that subtitle file.",
  emptyError: "No subtitles found in that file.",
};

export async function loadSubtitleFiles(
  files: File[],
  messages: SubtitleFileLoaderMessages = DEFAULT_MESSAGES
): Promise<EditorSubtitleLoadResult> {
  const file = files[0];
  if (!file) return { ok: false, error: messages.readError };
  try {
    const cues = parseToCues(await file.text());
    if (cues.length === 0) return { ok: false, error: messages.emptyError };
    return { ok: true, cues };
  } catch {
    return { ok: false, error: messages.readError };
  }
}
